module.exports = __webpack_public_path__ + "static/media/people1.695710cc.png";